import {
  Autocomplete,
  Chip,
  ListItem,
  ListItemText,
  TextField,
} from "@mui/material";
import { Dispatch } from "react";
import { FormInput } from "../../../lib/workout-form/transformers";
import { Action, FormInputs } from "../../../reducers/workoutReducer";
import { PublicUser, useUsers } from "../../../providers/users";

type Props = {
  dispatch: Dispatch<Action>;
  loading: boolean;
  coaches: FormInput;
};

const CoachInput = ({ dispatch, loading, coaches }: Props) => {
  const { usersExt, error, loading: usersLoading } = useUsers();

  
  const compareUsers = (userOne: PublicUser, userTwo: PublicUser) => {
    return (
      userOne.uid === userTwo.uid &&
      userOne.displayName === userTwo.displayName &&
      userOne.email === userTwo.email &&
      userOne.phoneNumber === userTwo.phoneNumber
    );
  };

  return (
    <Autocomplete
      disabled={loading}
      loading={usersLoading || error != null}
      loadingText={error != null ? error : "loading.."}
      multiple
      id="coaches"
      options={usersExt.filter((user) => user.isCoach)}
      value={coaches.input as PublicUser[]}
      getOptionLabel={(option: PublicUser) => option.displayName}
      isOptionEqualToValue={(option, value) => compareUsers(option, value)}
      onChange={(e, v: PublicUser[]) => {
        dispatch({
          type: FormInputs.coaches,
          payload: v?.map((user) => {
            return {
              uid: user.uid,
              displayName: user.displayName,
              email: user.email,
              phoneNumber: user.phoneNumber,
            };
          }) as PublicUser[]
        });
      }}
      renderTags={(values: readonly PublicUser[], getTagProps) => {
        return values.map((option: PublicUser, index: number) => {
          return (
            <Chip
              variant="outlined"
              label={option.displayName}
              {...getTagProps({ index })}
            />
          );
        });
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label="Tränare"
          placeholder="Tränare"
        />
      )}
      renderOption={(props, option: any) => {
        return (
          <ListItem {...props} key={option.uid}>
            <ListItemText
              primary={option.displayName}
              secondary={option.email}
            ></ListItemText>
          </ListItem>
        );
      }}
    />
  );
};

export default CoachInput;
